import MapRef from "@modules/location/types/MapRef";
import { useEffect, useMemo, useRef } from "react";
import MapHandler, {
  SEARCH_ZOOM,
} from "@modules/location/components/MapHandler";
import MapLocation from "@modules/locations/types/MapLocation";

type Props = {
  location: MapLocation | null;
  center?: { lat: number; lng: number };
};

const LocationMap = ({ location, center }: Props) => {
  const mapRef = useRef<MapRef>(null);
  const mapCenter = useMemo(() => {
    if (center) return center;

    return {
      lat: location?.address.latitude || 0,
      lng: location?.address.longitude || 0,
    };
  }, [center, location]);

  useEffect(() => {
    if (location && location.address.latitude && location.address.longitude) {
      mapRef.current?.setMapMarkers([location], false);

      mapRef.current?.centerMapLatLng(
        new google.maps.LatLng(mapCenter.lat, mapCenter.lng),
        SEARCH_ZOOM.max
      );
    }
  }, [mapCenter, location]);

  return <MapHandler ref={mapRef} />;
};

export default LocationMap;
